import { NgModule } from '@angular/core';
import { PaintableComponent } from './paintable.component';

@NgModule({
  declarations: [PaintableComponent],
  imports: [],
  exports: [PaintableComponent]
})
export class PaintableModule {}
